<ion-content [fullscreen]="true">
  <div
    style="display: flex; flex-direction: column; align-items: center; gap:8px; justify-content: center; width: 100%; height: 100%;">
    
    <img class="bounce" src="../../assets/img/ptcoins.svg" alt="PT Coins" style="width: 150px; height: 150px;" />
    
    <div style="font-size: 24px; text-align: center; padding: 24px;">
      <div style="margin-bottom: 24px;">
        Con questo contenuto puoi ottenere <b>{{t.company_training_prize}}</b> Punti Tempo extra!<br>
      </div>
      <p-message icon="pi pi-gift" severity="info">
        <div *ngIf="t.company_training_type==1" style="font-size: 1.2rem;">Otterrai i PT extra visualizzando un link.
        </div>
        <div *ngIf="t.company_training_type==2" style="font-size: 1.2rem;">Otterrai i PT extra accettando di essere
          ricontattato via e-mail.</div>
        <div *ngIf="t.company_training_type==3" style="font-size: 1.2rem;">Otterrai i PT extra comunicando i tuoi dati
        </div>
      </p-message>
    </div>






  </div>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-button *ngIf="!accepted" style="margin: 16px; font-size: 1rem;" fill="clear" expand="block" (click)="ignore()">
    <ion-label>Ignora PT Extra</ion-label>
  </ion-button>
  <ion-button style="margin: 16px; font-size: 1.1rem;" expand="block" (click)="accept()">
    <ion-label>{{accepted ? "Chiudi" : "Accetta PT Extra"}}</ion-label>
  </ion-button>
  
</ion-footer>